/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LocationDetailsForAzure extends models.LocationDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("LocationDetailsForAzure");
    }

    getFixupPrototypeFunction() { return LocationDetailsForAzure.fixupPrototype; }

    static newInstance(model: Partial<LocationDetailsForAzure>): LocationDetailsForAzure {
        let obj = Object.assign(new LocationDetailsForAzure(), model);
        LocationDetailsForAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LocationDetailsForAzure>): LocationDetailsForAzure {
        if (!model) return null;
        return LocationDetailsForAzure.newInstance(<LocationDetailsForAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LocationDetailsForAzure) {
        if (!obj) return;

        models.LocationDetailsForAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LocationDetailsForAzure): boolean {
        if (models.LocationDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LocationDetailsForAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
